const footer = document.querySelector('.footer');
const scrollToTopButton = document.getElementById('scroll-to-top');
const SCROLL_THRESHOLD = 300;

if (footer) {
    const footerResize = () => {
        const footerHeight = footer.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--footer', footerHeight + 'px');
    };

    window.onresize = footerResize;
    footerResize();
}

if (scrollToTopButton) {
    const updateButtonVisibility = () => {
        const isVisible = window.scrollY > SCROLL_THRESHOLD;

        if (isVisible) {
            scrollToTopButton.hidden = false;
            // Kurze Verzögerung damit der Browser das hidden=false verarbeitet, bevor die Klasse gesetzt wird
            requestAnimationFrame(() => {
                scrollToTopButton.classList.add('is-visible');
            });
        } else {
            scrollToTopButton.classList.remove('is-visible');
            // hidden setzen erst nach der Transition
            scrollToTopButton.addEventListener(
                'transitionend',
                () => { scrollToTopButton.hidden = true; },
                { once: true }
            );
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('scroll', updateButtonVisibility, { passive: true });
    scrollToTopButton.addEventListener('click', scrollToTop);
}
